import { atom } from "recoil";

export const FullScreenAtom = atom({
  key: "FullScreenAtom",
  default: false,
});
